module.exports = __webpack_public_path__ + "static/media/icc_festival.1a666870.png";